/** A cell as a number for a chart, or null when it is missing or not one. */
const readDatasourceNumber = (value: unknown): number | null => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  // A `numeric` column can arrive as a string, the way pg hands it out.
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);

    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
};

export default readDatasourceNumber;
